export default __webpack_public_path__ + "static/media/GWscreenshot.ccb181e0.PNG";